import http from "@/tools/http";

export default {
  getAllTree(orgUUID, params) {
    if (!params) {
      params = {};
    }
    params.format = "tree";
    return http.get(`/organizations/${orgUUID}/categories`, { params });
  },
  getAll(orgUUID, params) {
    return http.get(`/organizations/${orgUUID}/categories`, { params });
  },
  getOne(orgUUID, categoryUUID) {
    return http.get(`/organizations/${orgUUID}/categories/${categoryUUID}`);
  },
  create(orgUUID, data) {
    return http.post(`/organizations/${orgUUID}/categories`, data);
  },
  delete(orgUUID, catUUID) {
    return http.delete(`/organizations/${orgUUID}/categories/${catUUID}`);
  },
  update(orgUUID, data) {
    return http.patch(`/organizations/${orgUUID}/categories/${data.uuid}`, data);
  }
};
